'use client';

import CtaLink from '@/storyblok/wirfuersklima/functionalComponents/CtaLink';
import HeadlineField, { HeadlineTag } from '@/storyblok/wirfuersklima/functionalComponents/HeadlineField';
import ContentSection from '@/storyblok/wirfuersklima/functionalComponents/contentSection/ContentSection';
import type { SectionBgTextStoryblok } from '@/storyblok/wirfuersklima/types';
import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';
import { render } from 'storyblok-rich-text-react-renderer';

import classes from './SectionBgText.module.scss';

const SectionBgText: React.FC<{ blok: SectionBgTextStoryblok }> = ({ blok }) => {
  const { ref, inView } = useInView({ threshold: 0, rootMargin: '200px' });
  return (
    <div ref={ref}>
      <ContentSection
        blok={blok}
        className={`${classes['section-bg-text']} ${inView ? classes['section-bg-text--loaded'] : ''}`}
        anchorId={blok.anchor_id}
      >
        <div className="grid-wrapper">
          <div className={classNames(classes['section-bg-text__inner'], 'text-block')}>
            <HeadlineField tag={HeadlineTag.H2} style={HeadlineTag.H2}>
              {blok.headline}
            </HeadlineField>
            {render(blok.text)}
            {blok.cta_label != null && blok.cta_link != null && (
              <CtaLink link={blok.cta_link} label={blok.cta_label}>
                {blok.cta_label}
              </CtaLink>
            )}
          </div>
        </div>
      </ContentSection>
    </div>
  );
};

export default SectionBgText;
